import { DateTime } from "luxon";
import { z } from "zod";
import { zActiviteit, zRangeerbeweging } from "@personeel/gen/hey-api/zod.gen";

const activiteitOverrides = {
  tijd: z.iso.datetime({ offset: true }).transform((val) => DateTime.fromISO(val)),
} satisfies z.ZodRawShape;

export const ActiviteitSchema = zActiviteit.strip().extend(activiteitOverrides);

export const RangeerbewegingSchema = zRangeerbeweging.strip().extend({
  start: ActiviteitSchema,
  eind: ActiviteitSchema,
});

export type RangeerbewegingModel = z.infer<typeof RangeerbewegingSchema>;

export const RangeerbewegingenSchemaArray = z.array(RangeerbewegingSchema);

export type RangeerbewegingenModel = z.infer<typeof RangeerbewegingenSchemaArray>;
